import oldLocationData from '../../json/locationData'
import { deepClone } from '../../utils'

const location = {
  state: {
    locations: []
  },
  mutations: {
    setLocations(state, locations) {
      state.locations = deepClone(locations)
    }
  },
  actions: {
    SetLevel({ commit }, level) {
      return new Promise(resolve => {
        const isL1 = level === 1
        const isL2 = level === 2
        const isL3 = level === 3
        const isL4 = level === 4
        const locationData = JSON.parse(localStorage.getItem('addressData')) || oldLocationData
        const arr = deepClone(locationData)
        arr.forEach(L1 => {
          if (isL1) {
            delete L1.children
          } else {
            L1.children.forEach(L2 => {
              if (isL2) {
                delete L2.children
              } else if (L2.children) {
                L2.children.forEach(L3 => {
                  if (isL3) {
                    delete L3.children
                  } else if (L3.children) {
                    L3.children.forEach(L4 => {
                      if (isL4 && L4.children) {
                        delete L4.children
                      }
                    })
                  }
                })
              }
            })
          }
        })
        commit('setLocations', arr)
        resolve([...arr])
      })
    }
  }
}

export default location



// WEBPACK FOOTER //
// ./src/store/modules/location.js